import React, { ReactElement } from 'react';
import cm from 'classnames';

import { useAppSelector } from 'store/store-hooks';
import { selectHelpMode } from 'components/app/_mediator/app-data.slice';
import { TooltipPosition, Tooltip } from 'components/UI/tooltip/tooltip';
import { Select } from 'components/UI/select/select';
import styles from '../_ws-header.module.scss';

interface Props extends React.ComponentProps<typeof Select> {
  tip?: string | ReactElement;
  tipPosition?: TooltipPosition;
  className?: string;
}

export const WsSelect = ({ tip, tipPosition, className, ...rest }: Props) => {
  const helpMode = useAppSelector(selectHelpMode);
  return (
    <Tooltip tip={tip} position={tipPosition} showTooltip={helpMode}>
      <Select {...rest} className={cm(styles.WsSelect, className)} />
    </Tooltip>
  );
};
